import { shareReplay, distinctUntilChanged, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AdminQuestion } from '../models/questions';

@Injectable()
export class QuestionService {
  private apiController = 'api/admin/question';

  constructor(private httpService: HttpClient) {}

  getByCategoryId(id: number): Observable<Array<AdminQuestion>> {
    return this.httpService
      .get(`${this.apiController}/category/${id}`)
      .pipe(shareReplay()) as Observable<Array<AdminQuestion>>;
  }

  getOne(id: number): Observable<AdminQuestion> {
    return this.httpService
      .get(`${this.apiController}/${id}`)
      .pipe(shareReplay());
  }

  getLocalized(id: number): Observable<AdminQuestion> {
    return this.httpService.get(`${this.apiController}/${id}/localized`);
  }

  create(question: AdminQuestion) {
    return this.httpService
      .post(`${this.apiController}`, question)
      .pipe(shareReplay())
      .pipe(distinctUntilChanged());
  }

  update(question: AdminQuestion) {
    return this.httpService
      .put(`${this.apiController}/${question.id}`, question)
      .pipe(
        distinctUntilChanged(),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  delete(id: number) {
    return this.httpService.delete(`${this.apiController}/${id}`).pipe(
      distinctUntilChanged(),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
